import Cookies from 'js-cookie';
import { USERNAME } from '../constants/Constants';

export function setCookie(key: string, value: string) {
  Cookies.set(key, value);
}

export function getCookie(key: string) {
  return Cookies.get(key);
}

export function clearCookies() {
  setCookie('admin_token', '');
  setCookie('userInfo', '');
  setCookie('clientInfo', '');
  setCookie('entityInfo', '');
  setCookie(USERNAME, '');
}

export function clearCookie(key: string) {
  return Cookies.remove(key);
}
